// extracted by mini-css-extract-plugin
module.exports = {"openCloseIcon":"OpenCloseIcon_openCloseIcon__2N9bV","open":"OpenCloseIcon_open__KPjcI"};